export default __webpack_public_path__ + "static/media/Easter egg wreath_primary.bfd2a803.jpg";